// @flow

export default function debounce<T>(fn: Function): () => Promise<T> {
  let pending;
  return function() {
    if (!pending) {
      pending = new Promise<T>(resolve => {
        Promise.resolve().then(function() {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}
